import React from "react";
import ButtonClose from "../ButtonClose/ButtonClose"
import ButtonContainer from "../ButtonContainer/ButtonContainer"
import DynamicScrollbar from '../DynamicScrollbar/DynamicScrollbar';
import { Container, Title, Conditions, DescriptionText, ImageQR, ContainerToast, ImageInfo, Title2, DescriptionText2 } from "../../Styles/QrScreen/QrScreenStyle"
import { cancelOperation } from "../../shared/Constants/Constants"

function ContextQrScreen({cancel, acept }) {
  const title1 = "Escaneaste un QR para autenticarte";
  const title2 = "¿No generaste el código QR que te trajo aquí?";
  const descriptiontext1 = "Usaremos biometría facial para confirmar tu identidad y que continúes con seguridad.";
  const descriptiontext2 = "Si no lo hiciste, dale Cancelar.";
  const aceptButtonText = "Continuar";
  const rejectButtonText = "Cancelar";


  return (
    <Container>
      <ButtonClose cancel={cancel}/>
      <DynamicScrollbar>
        <Conditions>
          <ImageQR/>
          <Title>{title1}</Title>
          <DescriptionText marginBottom={"20px"}>{descriptiontext1}</DescriptionText>
          <ContainerToast>
              <ImageInfo/>
              <div>
                <Title2 marginBottom={"5px"}>{title2}</Title2>
                <DescriptionText2>{descriptiontext2}</DescriptionText2>
              </div>
          </ContainerToast>
          <ButtonContainer acept={acept} reject={cancel} aceptText={aceptButtonText} rejectText={rejectButtonText} canceltType={cancelOperation} />
        </Conditions>
      </DynamicScrollbar>
    </Container>
  );
}
export default ContextQrScreen;